var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seo-text-block module"},[(_vm.data.text)?_c('VaimoTruncatedText',_vm._b({staticClass:"module__text",attrs:{"markdown":""}},'VaimoTruncatedText',_vm.data,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }